export enum ThemeColorType {
    BLACK = "black",
    WHITE = "white",
    GRAY = "gray",
    GRAY_LIGHT = "gray-light",
    BRAND_CTA = "brand-cta",
    BRAND_1 = "brand-1",
    BRAND_2 = "brand-2",
    BRAND_3 = "brand-3",
    BRAND_4 = "brand-4",
    BRAND_5 = "brand-5"
}
